<template>
  <div class="collapseCard">
    <a
      class="collapseCardTitle"
      data-toggle="collapse"
      :data-target="`#collapseExample${collapse_key.replace(' ', '')}`"
      role="button"
      :style="toggle_style"
      :aria-controls="`collapseExample${collapse_key.replace(' ', '')}`"
      @click="onOff = !onOff"
      :aria-expanded="default_show"
    >
      <h5 class="inline secondary_title" :class="theme == 'vogue'? 'text-uppercase':''">{{ title }}</h5>
      <button type="button">
        <slot name="button">
          <span v-if="icon=='plus-minus'" class="rotate-plus-minus"></span>
          <span
            v-else
            :style="arrows_style"
            class="nextCrrows"
            :class="onOff ? 'arrows-top' : 'arrows-bottom'"
          ></span>
        </slot>
      </button>
    </a>
    <div
      class="collapse collapseCardMain"
      :class="default_show ? 'show' : ''"
      :id="`collapseExample${collapse_key.replace(' ', '')}`"
      :data-parent="onlyOnceTab ? parent : false"
      ref="content"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    title: {
      type: String,
    },
    default_show: {
      default: false,
    },
    collapse_key: {
      require: true,
    },
    toggle_style: {
      type: Object,
    },
    arrows_style: {
      type: Object,
    },
    icon: {
      type: String,
    },
    parent: {
      type: String,
    },
    theme: {},
  },
  data() {
    return {
      onOff: false,
    };
  },
  mounted() {
    if (this.default_show) {
      this.onOff = true;
    }
    
    // 被内容的ifram套一层div
    const dom = this.$refs.content;
    const iframes = this.$(dom).find('iframe');

    if (iframes.length > 0) {
      iframes.each(index => {
        this.$(iframes[index])?.wrapAll('<div class="detail-iframe-wrapper"></div>')
      })
    }
  },
  computed: {
    ...mapState({
      // 商品详情页打开一个Tab时，收起其他Tab
      onlyOnceTab: ({ options }) => options?.theme?.pages?.product?.config?.hasOwnProperty('only_once_tab') ? options.theme.pages.product.config.only_once_tab : true,
    }),
  },  
};
</script>
<style scoped lang='scss'>
button {
  border: none;
  background-color: transparent;
}
.collapseCard {
  border-bottom: 1px solid rgba(227, 227, 227, 0.6);
  .collapseCardTitle {
    .inline {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      padding-right: 19px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-overflow: -o-ellipsis-lastline;
    }
    text-decoration: none;
    color: black;
    position: relative;
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 12px;
    padding-bottom: 12px;
    cursor: pointer;
    &[aria-expanded="true"] {
      .rotate-plus-minus {
        &::after,
        &::before {
          -webkit-transform: translate(-50%, -50%) rotate(90deg);
          transform: translate(-50%, -50%) rotate(90deg);
        }
        &::before {
          opacity: 0;
        }
      }
    }
    h5 {
      font-size: 17px;
      padding-right: 20px;
    }
    button {
      outline: none; //消除默认点击蓝色边框效果
    }
  }
}
</style>